import Api from "../apiService";

class templateBlocksApi {
  index(companyId, templateId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/templates/${templateId}/template_fields`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, templateId, id) {
    return Api.getRequest(
      `companies/${companyId}/templates/${templateId}/template_fields/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, templateId, data) {
    return Api.postRequest(
      `companies/${companyId}/templates/${templateId}/template_fields`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, templateId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${templateId}/template_fields/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, templateId, id) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${templateId}/template_fields/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, templateId, id) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${templateId}/template_fields/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  reorder(companyId, templateId, data) {
    return Api.patchRequest(
      `companies/${companyId}/templates/${templateId}/template_fields/reorder`,
      data,
      Api.authHeaders()
    );
  }
}

export default new templateBlocksApi();
